import { Window } from "./Global";
import qs = require("qs");
import generate = require("nanoid/generate");

export class AuthenticationRelay {
  private tokenKeyName: string = "IS.AuthorizationData_" + this.GetTenant();
  constructor() {}

  public Configure() {
    let authenticationRelay = this;

    Window().addEventListener("message", function(event) {
      switch (event.data.Event) {
        case "Authorize":
          if (event.data.Data.acrValues != undefined) {
            authenticationRelay.Authorize(event.data.Data.otac, event.data.Data.acrValues);
          } else {
            authenticationRelay.Authorize(event.data.Data);
          }
          break;
        case "SignOut":
          authenticationRelay.SignOut();
          break;
        case "RenewToken":
          authenticationRelay.RenewToken();
          break;
        case "GetToken":
          console.log("GetToken -> NotityNewToken");

          authenticationRelay.NotityNewToken();
          break;
        case "Hash":
          authenticationRelay.Hash(event.data.Data);
          break;
      }
    });

    this.NotityNewToken();
    this.NotityRegistered();
  }

  public Authorize(otac: string, acrValues?: { [key: string]: string }) {
    this.SendMessage({ Event: "NeedAuthorize", Data: this.GenerateSigninUrl(otac, acrValues) });
  }

  private GenerateSigninUrl(otac: string, acrValues?: { [key: string]: string }) {
    let parameters = this.GetParameters();

    if (otac !== undefined && otac !== "") {
      parameters.AcrValues += " otac:" + otac;
    }

    if (acrValues !== undefined) {
      Object.keys(acrValues).forEach(key => {
        parameters.AcrValues += ` ${key}:` + acrValues[key];
      });
    }

    let authorizeParameters = {
      client_id: parameters.ClientId,
      redirect_uri: parameters.RedirectUri,
      response_type: parameters.ResponseType,
      scope: parameters.Scope,
      acr_values: parameters.AcrValues,
      nonce: this.GenerateNonce()
    };

    return parameters.AuthorityUri + "connect/authorize?" + qs.stringify(authorizeParameters);
  }

  public SignOut() {
    let signOutUrl = this.GenerateSignoutUrl();
    this.ClearToken();
    this.SendMessage({ Event: "NeedSignOut", Data: signOutUrl });
  }

  private GenerateSignoutUrl() {
    let parameters = this.GetParameters();
    let token = this.GetToken();
    if (token != null) {
      let tokenParameters = qs.parse(token);

      let authorizeParameters = {
        post_logout_redirect_uri: parameters.LogoutRedirectUri,
        id_token_hint: tokenParameters.id_token
      };

      return parameters.AuthorityUri + "connect/endsession?" + qs.stringify(authorizeParameters);
    }
  }

  private GetParameters(): any {
    let search = window.location.search.substring(window.location.search.indexOf("?") + 1);
    return qs.parse(search);
  }

  public Hash(hash: string) {
    this.SetToken(hash);
  }

  public RenewToken(): void {
    throw new Error("RenewToken not implemented");
  }

  public GenerateNonce(): string {
    var charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~";

    let nonce = generate(charset, 16);

    localStorage.setItem("nonce", nonce);

    return nonce;
  }

  public NotityNewToken(): void {
    this.SendMessage({ Event: "OnNewToken", Data: this.GetToken() });
  }

  public NotityRegistered(): void {
    this.SendMessage({ Event: "Registered", Data: this.GetName() });
  }

  private ClearToken() {
    localStorage.removeItem(this.tokenKeyName);
  }

  private SetToken(hash: string) {
    this.ClearToken();
    localStorage.setItem(this.tokenKeyName, hash);
    this.NotityNewToken();
  }

  private GetToken(): string | null {
    return localStorage.getItem(this.tokenKeyName);
  }

  private GetName() {
    return Window().name;
  }

  private ParseToken(token: string) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  }

  private SendMessage(message: any) {
    Window().parent.postMessage(message, "*");
  }

  private GetTenant() {
    let parameters = this.GetParameters();

    if (parameters.AcrValues !== undefined && parameters.AcrValues !== "") {
      let tenant = this.GetAcrValue("tenant", parameters.AcrValues.split(" "));
      if (tenant != null) {
        return tenant;
      }
    }
    return "default";
  }

  private GetAcrValue(value: string, acrValues: string[]): string | null {
    var values = acrValues.filter(function(acrValue) {
      return acrValue.indexOf(value + ":") >= 0;
    });

    if (values.length === 0) {
      return null;
    }

    let acr = values[0];
    if (acr === "") {
      return null;
    }
    var s = acr.split(":");
    if (s.length < 2) {
      return null;
    }
    return acr.split(":")[1];
  }
}
window.onload = () => {
  var relay = new AuthenticationRelay();
  relay.Configure();
};
